export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getAccountPolicySummaries: function getAccountPolicySummaries() {
            return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicySummaries', []);
        },

        checkLastReport: function checkLastReport(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'checkLastReport', [jobNumber]);
        },
        submitPartTimePerCapitas: function submitPartTimePerCapitas(jobNumber, data, type, sharedClass) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitPartTimePerCapitas', [jobNumber, data, type, sharedClass]);
        },
        getPartTimePerCapita: function getPartTimePerCapita(jobNumber, type, classCode, location, personsCovered) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPartTimePerCapita', [jobNumber, type, classCode, location, personsCovered]);
        },
        submitFullTimePerCapita: function submitFullTimePerCapita(jobNumber, data, type, sharedClass) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitFullTimePerCapita', [jobNumber, data, type, sharedClass]);
        },
        getFullTimePerCapita: function getFullTimePerCapita(jobNumber, type, classCode, location, personsCovered) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getFullTimePerCapita', [jobNumber, type, classCode, location, personsCovered]);
        },
        getFullTimeNumberOfDays: function getFullTimeNumberOfDays(jobNumber, startDate, endDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getFullTimeNumberOfDays', [jobNumber, startDate, endDate]);
        },
        updateDaysAndRepPerCapita: function updateDaysAndRepPerCapita(jobNumber, start, end) {
            return JsonRPCService.send('pc', 'gateway/policy', 'updateDaysAndRepPerCapita', [jobNumber, start, end]);
        },
        updateEndDateAndPerCapita: function updateEndDateAndPerCapita(jobNumber, start, end) {
            return JsonRPCService.send('pc', 'gateway/policy', 'updateEndDateAndPerCapita', [jobNumber, start, end]);
        },
        validateEndDate: function validateEndDate(policyNumber, startDate, endDate, termEffectiveDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'validateEndDate', [policyNumber, startDate, endDate, termEffectiveDate]);
        },
        validateStartDate: function validateStartDate(policyNumber, startDate, termEffectiveDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'validateStartDate', [policyNumber, startDate, termEffectiveDate]);
        },
        getPartTimeNumberOfDays: function getPartTimeNumberOfDays(jobNumber, startDate, endDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPartTimeNumberOfDays', [jobNumber, startDate, endDate]);
        },
        updateDays: function updateDays(jobNumber, start, end) {
            return JsonRPCService.send('pc', 'gateway/policy', 'updateDays', [jobNumber, start, end]);
        },
        updateEndDate: function updateEndDate(jobNumber, start, end) {
            return JsonRPCService.send('pc', 'gateway/policy', 'updateEndDate', [jobNumber, start, end]);
        },
        submitOneTimePartTimePerCapitas: function submitOneTimePartTimePerCapitas(jobNumber, data, sharedClass) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitOneTimePartTimePerCapitas', [jobNumber, data, sharedClass]);
        },
        submitOneTimeFullTimePerCapitas: function submitOneTimeFullTimePerCapitas(jobNumber, data) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitOneTimeFullTimePerCapitas', [jobNumber, data]);
        },
        getAccountPolicyDetails: function getAccountPolicyDetails(policyNumber) {
            return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicyDetails', [policyNumber]);
        },
        payrollReporting: function payrollReporting(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'payrollReporting', [policyNumber]);
        },
        payrollReportingForPolicyTerm: function payrollReportingForPolicyTerm(policyNumber, termNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'payrollReportingForPolicyTerm', [policyNumber, termNumber]);
        },
        getPolicyTerms: function getPolicyTerms(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyTerms', [policyNumber]);
        },
        getPayrollDataForPeriod: function getPayrollDataForPeriod(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPayrollDataForPeriod', [jobNumber]);
        },
        getPolicyTransactionsForPolicy: function getPolicyTransactionsForPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyTransactionsForPolicy', [policyNumber]);
        },
        removeDocument: function removeDocument(publicID) {
            return JsonRPCService.send('pc', 'policy/docs', 'removeDocument', [publicID]);
        },
        savePayrollReportData: function savePayrollReportData(jobNumber, payrollSummary) {
            return JsonRPCService.send('pc', 'gateway/policy', 'savePayrollReportData', [jobNumber, payrollSummary]);
        },
        savePayrollDataOnClickToReport: function savePayrollDataOnClickToReport(jobNumber, payrollSummary) {
            return JsonRPCService.send('pc', 'gateway/policy', 'savePayrollDataOnClickToReport', [jobNumber, payrollSummary]);
        },
        submitPayrollReportData: function submitPayrollReportData(jobNumber, payrollSummary, payrollEdit) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitPayrollReportData', [jobNumber, payrollSummary, payrollEdit]);
        },
        createActivityForPortalChanges: function createActivityForPortalChanges(policyNumber, periodStart, periodEnd, actionType, reason, description) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createActivityForPortalChanges', [policyNumber, periodStart, periodEnd, actionType, reason, description]);
        },
        submitOneTimePayrollReportData: function submitOneTimePayrollReportData(jobNumber, payrollSummary, payrollEdit) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitOneTimePayrollReportData', [jobNumber, payrollSummary, payrollEdit]);
        },
        getPremium: function getPremium(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPeriodPremium', [jobNumber]);
        },
        editPayrollReport: function editPayrollReport(jobNumber, policyNumber, startDate, endDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'editPayrollReport', [jobNumber, policyNumber, startDate, endDate]);
        },
        validateOwnerOfficerRepPayroll: function validateOwnerOfficerRepPayroll(jobNumber, payrollSummary) {
            return JsonRPCService.send('pc', 'gateway/policy', 'validateOwnerOfficerRepPayroll', [jobNumber, payrollSummary]);
        },
        checkReverseIsVisible: function checkReverseIsVisible(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'checkReverseIsVisible', [jobNumber]);
        },
        getOpenPolicyChangesForPayroll: function getOpenPolicyChangesForPayroll(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getOpenPolicyChangesForPayroll', [jobNumber]);
        },
        getCurrentDate: function getCurrentDate() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getCurrentDate');
        },
        getPerCapitaCodesByPolicyNumber: function getPerCapitaCodesByPolicyNumber(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPerCapitaCodesByPolicyNumber', [policyNumber]);
        },
        getPerCapitaCodesByJobNumber: function getPerCapitaCodesByJobNumber(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPerCapitaCodesByJobNumber', [jobNumber]);
        },
        getCurrency: function getCurrency() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getCurrency', []);
        },
        getAuditStatus: function getAuditStatus(jobNumber, payrollSummary) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getAuditStatus', [jobNumber, payrollSummary]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policy/common/services/PolicyService.js
// module id = 2077
// module chunks = 0